// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';
import { PresupuestoHelper } from 'helpers/Costos/PresupuestoHelper';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    orders: [],

    //hay que declarar el estado inicial
    inbound: [],
    //esta respuesta booleana sirve para mostrar el componente si tienes o no presupuestos, ya que todo lo manejamos como array y no hay manera de distinguir la primera instancia, osea ser nuevo
    inboundRespuesta: false,
};

const slice = createSlice({
    name: 'inbound',  //como se llama al metodo para luego ingresar a la respuesta ej inbound.inbound
    initialState,
    reducers: {

        // GET Inbound
        getInboundSuccess(state, action) {
            state.inbound = action.payload;
            state.inboundRespuesta = true;
        },

        hasError(state, action){
            state.inbound = [];
            state.error = action.payload;
        }

        
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------


export function getInbound(accessToken) {
    return async (dispatch) => {
        try {
            const response = await PresupuestoHelper.fetchDataInbound(accessToken); 
            dispatch(slice.actions.getInboundSuccess(response));
            console.log('Get Inbound :');
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            console.error('Error en consulta Inbound :', error);
        }
    };
};

export function getInbound_Id_pais( name, id, accessToken) {
    return async (dispatch, getState) => {
        try {
            // Acceder al estado completo de Redux
            const state = getState();
            const permisos = state.permisos.permisos; //accedo estado permisos
            // Verificar si alguno de los roles es 'CEO', 'Gerencia' o 'Lider'
            const rolesPermitidos = ['CEO', 'Gerencia', 'Lider'];
            const tienePermiso = permisos.some(permiso => rolesPermitidos.includes(permiso));
            
            let response;
            if(tienePermiso){
                response = await PresupuestoHelper.fetchDataInbound_Id_Pais( 'all', id, accessToken); 
            }else{
                response = await PresupuestoHelper.fetchDataInbound_Id_Pais( name, id, accessToken);  
            }
            dispatch(slice.actions.getInboundSuccess(response));
            console.log('Get Inbound Id, Pais:');
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            console.error('Error en consulta Inbound :', error);
        }
    };
};



